var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"d-block text-white label",style:(_vm.getCss)},[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.quantity)?_c('span',[_vm._v(_vm._s(_vm.quantity))]):_vm._e(),_c('br'),(_vm.ratios)?[_vm._v("(Soit "+_vm._s(_vm.ratios)+"%)")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }